<template lang="pug">
  v-container(fluid grid-list-md)
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{$t('pageHeader.purchase')}}
        v-btn(color='teal', dark, small, absolute, bottom, right, fab @click="$router.push('/inventory/purchase/create')")
          v-icon add
      v-card-title
        v-flex(xs12 sm4)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
      v-data-table(:headers='headers', :items='purchase', :search="search", :loading='loading', :pagination.sync='pagination')
        template(slot='items', slot-scope='props')
          tr.pointer
            td.text-xs-left {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
            td.text-xs-left {{ props.item.vendorName }}
            td.justify-end.layout.px-0
              v-menu(bottom, left offset-y)
                v-btn(slot='activator', icon)
                  v-icon more_vert
                v-list.menu-button
                  v-list-tile(@click='editProduct(props.item)')
                    v-list-tile-title {{ $t('buttons.edit') }}
                  //- v-list-tile(@click='deleteTask(props.item)')
                  //-   v-list-tile-title {{ $t('buttons.delete') }}
        v-alert(slot='no-results', :value='true', color='error', icon='warning')
          | Your search for "{{ search }}" found no results.
</template>

<script>
import puarchaseService from "../service";

export default {
  name: "product-list",
  data() {
    return {
      headers: [
        {
          text: 'Created At',
          value: "createdAt",
          sortable: true
        },
        {
          text: 'Vendor Name',
          align: "left",
          value: "vendorName",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      purchase: [],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createdAt",
        descending: false
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      return puarchaseService.getAll().then(response => {
        console.log("dfdfdfd", response);
        this.loading = false;
        this.purchase = response.data;
        return response;
      });
    },
    editProduct(product) {
      this.selectedProduct = product
      this.editDialog = !this.editDialog;
    },
    deleteProduct(product) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          productService.delete(product.id).then(response => {
            if (response.data) {
              this.$swal("Deleted!", "Product has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    }
  }
};
</script>
